'use client';

import { Badge } from '@repo/ui';
import type { JSX } from 'react';

interface IClipsNavigationProps {
  clipCount?: number;
}

export function ClipsNavigation({ clipCount }: IClipsNavigationProps): JSX.Element {
  return (
    <div className="mt-4 flex items-center gap-2">
      <span className="text-sm font-medium">Clips</span>
      {clipCount != null && clipCount > 0 && <Badge variant="secondary">{clipCount}</Badge>}
    </div>
  );
}
